import React from 'react'
import { useForm } from 'react-hook-form'
import axios from 'lib/axios'

export default function IntakeSchedule({ intakeSchedule, organizationId, updateIntakeSchedule }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
    clearErrors,
  } = useForm({
    defaultValues: {
      response_min: intakeSchedule.response.min,
      response_max: intakeSchedule.response.max,
      processing_min: intakeSchedule.processing.min,
      processing_max: intakeSchedule.processing.max,
    },
    mode: 'onSubmit',
  })

  const onFormSubmit = async (data, _event) => {
    clearErrors()
    try {
      const url = `/super/organizations/${organizationId}/questionnaires/update_intake_schedule`
      const response = await axios.post(url, data)
      updateIntakeSchedule(response.data.intake_schedule)
    } catch (e) {
      console.log(e)

      // Handle backend validation errors
      if (e.response && e.response.data && e.response.data.error) {
        const backendErrors = e.response.data.error

        // Set errors for each field returned from backend
        Object.keys(backendErrors).forEach((fieldName) => {
          setError(fieldName, {
            type: 'server',
            message: backendErrors[fieldName].join(', '),
          })
        })
      } else {
        // Generic error handling
        setError('root.serverError', {
          type: 'server',
          message: e.response?.data?.message || 'An error occurred while updating',
        })
      }
    }
  }

  return (
    <div className="intake-schedule">
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <div className="dome-d-flex dome-flex-column dome-gap6">
          {/* Display root server error if exists */}
          {errors.root?.serverError && (
            <div className="dome-p2 dome-color-red-alert">{errors.root.serverError.message}</div>
          )}

          <div className="questionnaire-admin-general-row">
            <div className="dome-p1 dome-color-darkest-grey">response</div>

            <div className="dome-d-flex dome-align-center dome-gap6">
              <div className="intake-schedule__input-field">
                <label className="dome-p2 dome-color-med-grey">min days</label>
                <input
                  type="number"
                  min={0}
                  {...register('response_min')}
                  className="intake-scheldule__input-field-input"
                />
                {errors.response_min && (
                  <span className="dome-p3 dome-color-red-alert">{errors.response_min.message}</span>
                )}
              </div>

              <span className="intake-schedule__separator">—</span>

              <div className="intake-schedule__input-field">
                <label className="dome-p2 dome-color-med-grey">max days*</label>
                <input
                  type="number"
                  min={0}
                  {...register('response_max', { required: true })}
                  className="intake-scheldule__input-field-input"
                />
                {errors.response_max && (
                  <span className="dome-p3 dome-color-red-alert">{errors.response_max.message}</span>
                )}
              </div>
            </div>
          </div>

          <div className="questionnaire-admin-general-row">
            <div className="dome-p1 dome-color-darkest-grey">processing</div>

            <div className="dome-d-flex dome-align-center dome-gap6">
              <div className="intake-schedule__input-field">
                <label className="dome-p2 dome-color-med-grey">min days</label>
                <input
                  type="number"
                  min={0}
                  {...register('processing_min')}
                  className="intake-scheldule__input-field-input"
                />
                {errors.processing_min && (
                  <span className="dome-p3 dome-color-red-alert">{errors.processing_min.message}</span>
                )}
              </div>

              <span className="intake-schedule__separator">—</span>

              <div className="intake-schedule__input-field">
                <label className="dome-p2 dome-color-med-grey">max days*</label>
                <input
                  type="number"
                  min={0}
                  {...register('processing_max', { required: true })}
                  className="intake-scheldule__input-field-input"
                />
                {errors.processing_max && (
                  <span className="dome-p3 dome-color-red-alert">{errors.processing_max.message}</span>
                )}
              </div>
            </div>
          </div>

          <div className="dome-d-flex dome-align-start">
            <button type="submit" className="dome-btn dome-btn-base dome-btn-aqua-stroke">
              update
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}
